import { Table } from "antd";
import { User } from "@ticketingplatform/api/dist/users/__generated__/fragments";
import { VenueUser } from "@ticketingplatform/api/dist/venueUser/fragments/__generated__/venueUser";

import { useUserColumns } from "./hooks";
import { UserTableProps } from "./types";

const UserTable = <TRecord extends User | VenueUser = User>({
  additionalColumns,
  sortOrder,
  ...props
}: UserTableProps<TRecord>): React.ReactElement => {
  const columns = useUserColumns({ additionalColumns, sortOrder });

  return <Table rowKey="id" {...{ columns }} {...props} />;
};

export default UserTable;
